export default __webpack_public_path__ + "static/media/singinglady.c541ea54.png";